<template>
  <v-container fluid>
    <h2>Liste af medlemmer der endnu ikke har betalt kontingent i år</h2>
    <br/>
    <v-btn @click="betalalle()">Igangsæt opkrævning for alle</v-btn>
    <br/>
    <br/>
    <v-skeleton-loader
      :loading="loading"
      type="table"
    >
      <!-- Content after loading goes here -->
      <v-data-table
        :headers="medlemsheaders"
        :items="medlemmer"
        :items-per-page="50"
        :loading="loading"
        class="elevation-1"
      >
      <template v-slot:[`item.id`]="{ item }">
        <router-link :to="`/medlemsdata/${item.id}`">{{ item.id }}</router-link>
      </template>
      <template v-slot:[`item.active`]="{ item }">
        <v-simple-checkbox v-model="item.active" disabled></v-simple-checkbox>
      </template>
      <template v-slot:[`item.nyhedsbrev`]="{ item }">
        <v-simple-checkbox v-model="item.nyhedsbrev" disabled></v-simple-checkbox>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="betal(item)">Igangsæt opkrævning</v-btn>
      </template>
      </v-data-table>
    </v-skeleton-loader>
    <br/>
  </v-container>
</template>

<script>

import MedlemsService from '@/services/MedlemsService'

export default {
  name: 'Kontingent',
  data: () => ({
    loading: true,
    medlemsheaders: [
      {
        text: 'Medlemsnummer',
        align: 'start',
        value: 'id'
      },
      {
        text: 'Medlem siden',
        value: 'createdAt'
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Navn',
        value: 'navn'
      },
      {
        text: 'Adresse',
        value: 'adresse'
      },
      {
        text: 'Postnr',
        value: 'postnummer'
      },
      {
        text: 'By',
        value: 'by'
      },
      {
        text: 'Telefon',
        value: 'telefon'
      },
      {
        text: 'Medlemstype',
        value: 'medlemstype'
      },
      {
        text: 'Nyhedsbrev',
        value: 'nyhedsbrev'
      },
      {
        text: 'Aktiv',
        value: 'active'
      },
      {
        text: 'Sidst betalt',
        value: 'lastPayment'
      },
      {
        text: 'Opkræv',
        value: 'actions',
        sortable: false
      }
    ],
    medlemmer: null,
    betalresult: null
  }),
  methods: {
    async betal (item) {
      this.betalresult = await MedlemsService.intiateKontingentBetaling(item.id)
    },
    async betalalle () {
      this.betalresult = await MedlemsService.intiateKontingentBetalinger()
    }
  },
  watch: {
    betalresult: function () {
      alert(this.betalresult.data.message)
    }
  },
  async mounted () {
    const medlemsdata = await MedlemsService.kontingentliste()
    this.medlemmer = medlemsdata.data
    this.loading = false
  }
}
</script>
